
import React from 'react'
import AsyncSelect  from 'react-select/async';
import {components } from 'react-select';
import {MdSearch} from 'react-icons/md'
import { bgColors } from '../../utils/bgColor';
// import SearchSharpIcon from '@mui/icons-material/SearchSharp';
const AsyncSelectSearch= props =>{
    const {onChange,loadOptions, ...otherProps } = props
    const styles = {
        control: (base, state) => ({
            ...base,
            background: bgColors.grey_300,
            // height:'15px',
            width:'100%',
            // match with the menu
            // borderRadius: state.isFocused ? bgColors.grey_300 : 10,
            // Overwrittes the different states of border
            borderColor: state.isFocused ? bgColors.grey_300 : bgColors.grey_300,
            // Removes weird border around container
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
              // Overwrittes the different states of border
              borderColor: state.isFocused ? bgColors.grey_300 : bgColors.grey_300,
              // borderRadius: state.isFocused ? bgColors.grey_300 : 10,
            },
            "&:focussed": {
                // Overwrittes the different states of border
                borderColor: state.isFocused ? bgColors.grey_300 : bgColors.grey_300,
                // borderRadius: state.isFocused ? bgColors.grey_300 : 10,
              }
          }),
        valueContainer: base => ({
          ...base,
          paddingLeft: 40,
        //   backgroundColor: bgColors.grey_900,
          // color:bgColors.grey_300
        }),
        menuList: styles => ({
            ...styles,
            background: bgColors.grey_300,
            color:bgColors.grey_800,
            borderRadius:5,
           
        }),
        option: (styles, {isFocused, isSelected}) => ({
            ...styles,
            background: isFocused
                ? bgColors.blue_500
                : isSelected
                    ? bgColors.grey_400
                    : undefined,
            zIndex: 10,
        }),
    
      };
    
    const ValueContainer = ({ children, ...props }) => {
        return (
          components.ValueContainer && (
            <components.ValueContainer {...props}>
              {!!children && (
                <i
                  className="fa fa-menu"
                  aria-hidden="true"
                  style={{ position: "absolute", right: 6 }}
                />
              )}
              {children}
            </components.ValueContainer>
          )
        );
      };

    
      const DropdownIndicator = props => {
        return (
          components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
              {/* <IconButton> */}
              <MdSearch style = {{height:'25px', width:'25px'}}/>
              {/* </IconButton> */}
            </components.DropdownIndicator>
          )
        );
      };


  
      return (
        <AsyncSelect
        {...props}
        complete
        // closeMenuOnSelect={false}
        onChange = {onChange}
        placeholder={ "village > sub-district"}
        // loadOptions = {loadOptions}
        components={{DropdownIndicator,ValueContainer}}
        styles={styles}
        />
      )

}

export default AsyncSelectSearch



